export const phoneTypesOptions = [
  {
    label: "Work",
    value: "work",
  },
  {
    label: "Home",
    value: "home",
  },
  {
    label: "Cell",
    value: "cell",
  },
];
